import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "self-stretch justify-start items-start gap-4 inline-flex" }
const _hoisted_2 = { class: "justify-start items-end gap-4 inline-flex" }

import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { IReviewSummaryItem } from '@/interfaces';

// Define props and emitters
// ------------------------------------------------------------- //

export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryListItem',
  props: {
    item: {},
    isLastReviewSummaryItem: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["self-stretch pb-4 md:pb-2 md:pt-1 border-racq-light-blue-grey flex-col justify-start items-start flex", !_ctx.isLastReviewSummaryItem ? 'border-b' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(RichText), {
        field: _ctx.item.title,
        class: _normalizeClass(["grow text-racq-dark-grey text-base", !_ctx.isLastReviewSummaryItem ? 'text-base' : 'text-lg-bold'])
      }, null, 8, ["field", "class"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(RichText), {
          field: _ctx.item.content,
          class: "text-racq-dark-grey text-base-bold"
        }, null, 8, ["field"]),
        _renderSlot(_ctx.$slots, "edit")
      ])
    ])
  ], 2))
}
}

})